module.exports = __webpack_public_path__ + "img/crown.6f9eb9cc.png";